<div class="container1 my-5 py-5 text-center rounded shadow" style="background-color: #ffffff;">
  <h2 class="font-weight-bold mb-3" style="color: #045762;">Start Your Child’s Journey With Us</h2>
  <p class="lead text-muted mb-4">Discover a nurturing environment where learning and values grow together.</p>
  <button class="btn btn-lg" style="background: linear-gradient(90deg, #077A7D, #7AE2CF); color: white; border: none;" routerLink="/contact-us">
    Get in Touch
  </button>
</div>
  <div class="container">
    <div class="row">
    </div>
  </div>
  <br>
<footer class="custom-navbar text-white py-4">
  <div class="container">
    <div class="row text-center text-md-start">
      <!-- Logo + Title Section -->
      <div class="col-md-4 d-flex flex-column align-items-center justify-content-center mb-4 mb-md-0">
        <img class="logo-img mb-3" src="../../assets/img/icon/LOGO.png" width="80px" alt="School Logo" style="border-radius: 50%;"/>
        <h2 class="text-white fw-bold text-center" style="font-weight: bold;">Your Child’s Future Begins Here</h2>
      </div>

      <!-- Important Links Section -->
      <div class="col-md-4 mb-4 mb-md-0">
        <h5 style="color: #ffffff; font-weight: bold;">Important Links</h5>
        <ul class="list-unstyled">
          <li><a href="#" class="text-white" style="font-weight: bold;">Home</a></li><br>
          <li><a routerLink="/about-us" class="text-white "style="font-weight: bold;" >About Us</a></li><br>
          <li><a routerLink="/verticals" class="text-white" style="font-weight: bold;">Our-Management</a></li><br>
          <li><a routerLink="/gallery" class="text-white" style="font-weight: bold;">Gallery</a></li><br>
          <li><a routerLink="/contact-us" class="text-white" style="font-weight: bold;">Contact</a></li><br>
        </ul>
      </div>

      <!-- Contact Info Section -->
      <div class="col-md-4">
        <h5 style="font-weight: bold; color: ffffff;">Contact Info</h5>
        <br>
        <p style="font-weight: bold;">Sri Parasakthi vidyalaya- CBSE, Courtallanathar road <br> Courtallam.627 802, Tamil Nadu.</p>
        <br>
        <p style="font-weight: bold;">LandLine No: 04633 212993</p>
        <b style="font-weight: bold;">Office No : 8122983133</b>
      </div>
    </div>

    <div class="text-center mt-4">
      <a href="tel:04633 283133" class="me-3">
        <i class="fa fa-phone text-white" style="font-size: 25px;"></i>
      </a>&nbsp;&nbsp;&nbsp;&nbsp;
      <a href="mailto:sriparasakthividyala@yahoo.co.in" class="me-3">
        <i class="fa fa-envelope text-white" style="font-size: 25px;"></i>
      </a>&nbsp;&nbsp;&nbsp;&nbsp;
      <a href="https://wa.me/8122983133" target="_blank">
        <i class="fa fa-whatsapp text-white" style="font-size: 25px;"></i>
      </a>
      <br><br>
      <p style="font-weight: bold; color: ffffff;">&copy; 2026 Parasakthi School. All rights reserved.</p>
      <a href="http://annaasilicontechnology.com/#/" target="_blank" style="font-size: 10px; color: ffffff; text-decoration: none;">
        Designed by AnnaaSiliconTechnology.Pvt.Ltd.,®
      </a>
    </div>
  </div>
</footer>


  <style>
    .responsive-text {
      font-size: 5px;
      font-weight: bold;
      color: #f8f6f6;
    }
  
    /* For mobile devices */
    @media (max-width: 576px) {
      .responsive-text {
        font-size: 2px; /* Adjust as needed */
      }
    }
  
    /* For tablets */
    @media (min-width: 577px) and (max-width: 768px) {
      .responsive-text {
        font-size: 5px; /* Adjust as needed */
      }
    }
  
    /* For desktops */
    @media (min-width: 769px) {
      .responsive-text {
        font-size: 30px; /* Default size */
      }
    }
  </style>
  